"use client";
import React from "react";
import Image from "next/image";
import { Center, Heading, Stack } from "@chakra-ui/react";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Text } from "@/elements";
import { OFFERING_CONSTANTS } from "./constants";

const VeeamGraphics = () => {
  const { title, text, image } = OFFERING_CONSTANTS;
  const textVariant = useTextVariant();
  return (
    <Stack gap={6} mb={12}>
      <Heading
        as="h2"
        fontWeight={"400"}
        fontSize={"40px"}
        whiteSpace={"pre-line"}
        textAlign={"center"}
        lineHeight={"45px"}
      >
        {title}
      </Heading>
      <Text
        textAlign={"center"}
        variant={textVariant}
        color={"text.100"}
        fontWeight={600}
      >
        {text}
      </Text>
      <Center>
        <Image
          src={image}
          alt="Veeam Offerings"
          style={{ height: "auto", maxWidth: "600px", width: "100%" }}
        />
      </Center>
    </Stack>
  );
};

export default VeeamGraphics;
